const actions = {
  SET_STATE: 'etc/SET_STATE',
  SET_UI_DATA: 'etc/SET_UI_DATA',
}

export default actions
